import { Directive } from '@angular/core';

@Directive({
  selector: '[phx-list-avatar]',
  host: { class: 'phx-list-avatar phx-list-pre' },
})
export class PhxListItemAvatarDirective { }
